import { Create, Edit, List, Show, OutList, BulkCreate, LeaveApproved, Calendar, BulkEntry } from "../Components/index.js";

export default [
    {
        path: "/visitor",
        component: List,
        name: "visitor",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/visitor-in-out",
        component: OutList,
        name: "visitor.out",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/visitor/entry",
        component: Create,
        name: "visitor.entry",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/visitor/bulk-entry",
        component: BulkEntry,
        name: "visitor.bulk.entry",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/visitor/bulk-create",
        component: BulkCreate,
        name: "visitor.bulk.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/visitor/entry/:id/show",
        component: Show,
        name: "visitor.entry.show",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/rp/approved-leave",
        component: LeaveApproved,
        name: "rp.approved",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/rp/calendar",
        component: Calendar,
        name: "rp.calendar",
        meta: {
            requiresAuth: true,
        },
    },
];
